import React from 'react';
import '../../App.css';
import FormContainer from "../Form/FormContainer";

const App: React.FC = () => {
    return (
            <>
                <div className="bg-col"/>
                <FormContainer/>
            </>
    );
};

export default App;
